import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import { StatusOption } from '../../utils'

export enum FieldStatusEnum {
  EMPTY = 'EMPTY',
  NEW = 'NEW',
  CHANGED = 'CHANGED'
}

type FieldStatusOption = StatusOption & {
  color: TailwindColor
  bgColor: TailwindColor
}

export const fieldStatusEnumMapping: Record<FieldStatusEnum, FieldStatusOption> = {
  [FieldStatusEnum.EMPTY]: {
    label: '-',
    color: tailwindColors.red.DEFAULT,
    bgColor: tailwindColors.red.light.DEFAULT
  },
  [FieldStatusEnum.NEW]: {
    label: 'Nouveau',
    variant: 'blue',
    color: tailwindColors.orange.DEFAULT,
    bgColor: tailwindColors.orange.light.DEFAULT
  },
  [FieldStatusEnum.CHANGED]: {
    label: 'Changement IBAN',
    variant: 'orange',
    color: tailwindColors.green.DEFAULT,
    bgColor: tailwindColors.green.light.DEFAULT
  }
}
